import React, { useEffect } from 'react';
import { useTranslation, useUserInfoStore } from '@pascal/pascal-core';
import { soundService } from '../../services/SoundService';

export function MobileWinPopup({ winningAmount }) {
  const t = useTranslation();
  const { currencyCode } = useUserInfoStore();

  useEffect(() => {
    soundService.playWin();
  }, []);

  return (
    <div className='m-win-popup'>
      <div className='m-win-popup-inner'>
        <p className='m-win-popup-title'>{t('YOU_WIN')}</p>
        <p className='m-win-popup-info'>
          {winningAmount} {currencyCode}
        </p>
      </div>
    </div>
  );
}
